<template>
    <transition name="fade">
        <div class="vue-modal" v-show="open" style="margin-top:170px;">
            <transition name="drop-in">
                <div class="vue-modal-inner" v-show="open">
                    <div class="vue-modal-content" style="color: var(--theme-text-main);">
                        <slot />
                        <p class="h3 text-seccess fw-bold">Please login to get authorization</p>
                        <label title="User Name">User Name</label>
                        <input type="text" v-on:keyup.enter="Void()" class="form-control" name="UserName" id="VoidUserName" v-model="username"/>
                        <label title="Password">Password</label>
                        <input type="password" v-on:keyup.enter="Void()" class="form-control" name="Password" id="VoidPassword" v-model="password"/>
                        <br>
                        <table style="width:100%"> 
                            <tr> 
                                <td> 
                                </td> 
                                <td> 
                                    <button @click="Void()" class="btn btn-success">Check For Permission</button>
                                </td> 
                                <td> 
                                    <button @click="close" class="btn btn-danger">Close</button>                                    
                                </td> 
                                <td> 
                                </td> 
                                <td> 
                                </td> 
                            </tr> 
                        </table>
                    </div>
                </div>
            </transition>
        </div>
    </transition>
</template>
<script>

import axios from "axios";
import commonServices from "@/shared/commonServices"

export default {
    mixins: [commonServices],
    name:"Void",
    mounted() {
        this.$el.querySelector('#VoidUserName').focus = true;
    }, 

    data: function(){
        return {
            username : '',
            password : '',
            authorizedToChangePrice : 'N',
            authorizedToPayReturn : 'N',
            void_user_id: '',

        }
    },
    methods:{
        passVoidPermission()
        {
            this.username = '';
            this.password = '';
            this.$emit('getVoidUserId', this.void_user_id)
            this.$emit('getVoidPermission', this.authorizedToChangePrice)
            this.$emit('getPayReturnPermission', this.authorizedToPayReturn)
            this.$emit('getDeletePermission', this.authorizedToPayReturn)
        },
        Void: async function(){
            try{
                //Void API
                //let dataURL = this.apiURL+'Users/checkForVoidPermision';
                let dataURL = this.apiURL+'Users/checkForVoidPermision';

                let loginJson = {'action': 'login', 'username': this.username, "password" : this.password};
                let response = await axios.post(dataURL, loginJson); 
                //let response = await axios.post(dataURL, {"appId":"7", "username":"viamenu", "password":"Demo123"}); 
                //console.log(response.data);
                if(response.data.void === true){

                    this.authorizedToChangePrice = 'Y';
                    this.authorizedToPayReturn = 'Y';
                    this.void_user_id = response.data.id;
                    this.passVoidPermission();
                    this.close();
                }else{
                    this.showAlert("Not Permitted! ");
                }
            }
            catch (error){
                console.log(error);
            }
        }
    },
    props:{
        open: {
            type:Boolean,
            required:true
        },
    },
    setup(_, { emit }){
        const close = () => {
            emit('close');
        };

        return { close };
    },
};
</script>
<style scoped>
*,
::before

::after{
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}
.vue-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    background-color: rgba(0, 0, 0, 0.4);
    z-index: 1;
}
.vue-modal-inner {
    max-width: 50%;
    max-height: 50%;
    margin: 2rem auto;
}
.vue-modal-content {
    position: relative;
    background-color: var(--form-color);
    border: 5px solid rgba(0, 0, 0, 0.3);
    background-clip: padding-box;
    border-radius: 1rem;
    padding: 1rem;
    width: 100%;
    height: 100%;
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}
.drop-in-enter-active,
.drop-in-leave-active {
    transition: all 0.3s ease-out;
}
.drop-in-enter-from,
.drop-in-leave-to {
    opacity: 0;
    transform: translateY(50px);
}
</style>
